import { render, staticRenderFns } from "./MainForm.vue?vue&type=template&id=a2f8ef9a&scoped=true"
import script from "./MainForm.vue?vue&type=script&lang=js"
export * from "./MainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f8ef9a",
  null
  
)

export default component.exports